<template>
  <div id="app" style="padding: 0.5rem 0; text-align: left" class="vue-dpn">
    <div style="position: fixed; top: 0; left: 0; right: 0; z-index: 999">
      <van-nav-bar :title="pageTitle" @click-left="goBack" left-arrow />
    </div>

    <div style="padding: 56px 0.4rem 1.2rem 0.4rem">
      <div class="info-title">附件上传</div>

      <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
        <div v-for="(item, index) in fileList" :key="item" class="file-item">
          <div class="file-main" @click="viewFile(item)">
            <div class="file-name">{{ getFileNameFromUrl(item) }}</div>
            <div class="file-meta">上传类型：{{ isPdfUrl(item) ? 'pdf' : 'docx' }}</div>
            <div class="file-meta">
              <FileSizeCheck :url="item" :limit="8" />
            </div>
          </div>
          <div class="file-actions">
            <button class="file-action-btn" @click.stop="viewFile(item)">
              <van-icon name="eye-o" class="action-icon" />
              <span>查看</span>
            </button>
            <button class="file-action-btn file-action-delete" @click.stop="deleteFile(index)">
              <van-icon name="delete" class="action-icon" />
              <span>删除</span>
            </button>
          </div>
        </div>

        <a
          style="
            display: inline-block;
            width: 100%;
            border-radius: 0.125rem;
            line-height: 0.7rem;
            font-family: PingFangSC-Regular;
            font-size: 0.3rem;
            color: #1889f9;
            border: 1px solid #9f9f9f;
            text-align: center;
            position: relative;
          "
          href="javascript:void(0);"
        >
          <van-icon
            name="add-o"
            style="display: inline-block; margin-right: 6px; vertical-align: middle;"
          />
          <span style="display: inline-block; vertical-align: middle">添加文件</span>

          <input
            type="file"
            style="position: absolute; z-index: 999; top: 0; right: 0; bottom: 0; left: 0; opacity: 0;"
            accept="application/pdf,.docx"
            @change="getFile"
            ref="upload"
          />
        </a>
      </div>

      <div class="ps-text" style="padding: 0.2rem; text-align: left; opacity: 0.7">
        注：只支持.pdf,.docx格式的文件。
      </div>

      <div class="form-section" style="margin-top: 0.4rem">
        <div class="section-title">备注</div>
        <van-field
          v-model="remark"
          type="textarea"
          rows="3"
          placeholder="选填"
          autosize
        />
      </div>

      <van-button type="primary" block :loading="submitting" @click="submit" style="margin-top: 0.6rem;">
        保存
      </van-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import common from '@/assets/js/common'
import FileSizeCheck from '../components/FileSizeCheck.vue'

export default {
  name: 'NewInputInvoice',
  components: { FileSizeCheck },
  data () {
    return {
      id: null,
      remark: '',
      fileList: [],
      submitting: false
    }
  },
  computed: {
    pageTitle () {
      return this.id ? '编辑进项发票' : '上传进项发票'
    }
  },
  methods: {
    goBack () {
      this.$router.push({ path: '/input_invoice' })
    },
    isPdfUrl (url) {
      return /\.pdf$/i.test(url || '')
    },
    getFileNameFromUrl (url) {
      if (!url) return '文件'
      try {
        const parsedUrl = url.indexOf('http') === 0 ? new URL(url) : null
        const pathname = parsedUrl ? parsedUrl.pathname : url
        return pathname.substring(pathname.lastIndexOf('/') + 1) || '文件'
      } catch (e) {
        const parts = url.split('/')
        return parts[parts.length - 1] || '文件'
      }
    },
    toStoredPath (url) {
      if (!url) return ''
      const host = common.dynamicHost()
      if (url.indexOf(host) === 0) {
        return url.replace(host, '')
      }
      return url
    },
    toDisplayUrl (path) {
      if (!path) return ''
      if (path.indexOf('http') === 0) return path
      return common.dynamicHost() + path
    },
    viewFile (url) {
      if (!url) return
      const fileUrl = this.toDisplayUrl(url)
      window.open(fileUrl, '_blank')
    },
    deleteFile (index) {
      this.$dialog.confirm({
        title: '确认删除',
        message: '确定删除该文件吗？'
      }).then(() => {
        this.fileList.splice(index, 1)
      }).catch(() => {})
    },
    getFile () {
      const inputFile = this.$refs.upload.files[0]
      if (!inputFile) return

      if (
        inputFile.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' &&
        inputFile.type !== 'application/pdf'
      ) {
        common.mAlert(this, '不是有效的docx,pdf文件！')
        return
      }

      const formData = new FormData()
      formData.append('file', inputFile)

      axios.post(common.dynamicHost() + '/upload.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        this.$refs.upload.value = ''
        res = res.data
        if (res && res.errcode === 0) {
          this.fileList.push(common.dynamicHost() + res.path)
        } else {
          common.mAlert(this, '上传失败')
        }
      }).catch(() => {
        this.$refs.upload.value = ''
        common.mAlert(this, '上传失败')
      })
    },
    loadDetail () {
      common.cusHttp(this, '/admin_input_invoice.php?action=input_invoice_detail', { id: this.id }, 'get').then((res) => {
        res = JSON.parse(res.data)
        if (res.errcode === 0 && res.result) {
          this.remark = res.result.remark || ''
          this.fileList = (res.result.pdf_list || []).map(path => this.toDisplayUrl(path))
        } else {
          common.mAlert(this, res.errmsg || '加载失败')
          this.goBack()
        }
      })
    },
    submit () {
      if (!this.fileList.length) {
        common.mAlert(this, '请至少上传一个文件')
        return
      }
      this.submitting = true
      const data = {
        remark: this.remark,
        pdf_urls: JSON.stringify(this.fileList.map(url => this.toStoredPath(url)))
      }
      if (this.id) {
        data.id = this.id
      }
      common.cusHttp(this, '/admin_input_invoice.php?action=add_or_modify_input_invoice', data, 'post').then((res) => {
        this.submitting = false
        res = JSON.parse(res.data)
        if (res.errcode === 0) {
          common.mAlert(this, res.errmsg || '保存成功')
          this.goBack()
        } else {
          common.mAlert(this, res.errmsg || '保存失败')
        }
      }).catch(() => {
        this.submitting = false
        common.mAlert(this, '保存失败')
      })
    }
  },
  mounted () {
    if (!common.getAuth()) {
      this.$router.push({ path: '/auth' })
      return
    }
    common.removeDpnClass()
    if (this.$route.query.id) {
      this.id = parseInt(this.$route.query.id, 10)
      this.loadDetail()
    }
  }
}
</script>

<style scoped>
.info-title {
  font-size: 0.3rem;
  color: #212120;
  margin-bottom: 0.2rem;
  padding: 0 0.1rem;
}
.form-info-panel {
  background: #fff;
  border-radius: 0.16rem;
  border: 1px solid #e4e4e4;
  padding: 0.24rem 0.28rem 0.32rem;
}
.file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f0f2f5;
}
.file-item:last-of-type {
  border-bottom: none;
}
.file-main {
  flex: 1;
  min-width: 0;
}
.file-name {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  word-break: break-all;
}
.file-meta {
  font-size: 12px;
  margin-top: 4px;
  color: #9ca3af;
}
.file-actions {
  display: flex;
  flex-shrink: 0;
  gap: 4px;
}
.file-action-btn {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  border: none;
  background: transparent;
  color: #2563eb;
  font-size: 11px;
  line-height: 16px;
  padding: 4px 2px;
}
.file-action-btn .action-icon {
  display: block;
  font-size: 18px;
  line-height: 18px;
  margin-bottom: 2px;
}
.file-action-delete {
  color: #ef4444;
}
.form-section {
  background: #fff;
  border-radius: 0.16rem;
  padding: 0.32rem;
  border: 1px solid #e4e4e4;
}
.section-title {
  font-size: 0.28rem;
  color: #212120;
  margin-bottom: 0.24rem;
}
</style>
